import Model from 'ducker-model';

const property = {
  fundCode: String,
  pageType: String,
};

const replacedKeyFromPropertyName = {
  fundCode: {
    property: ['FCODE'],
    computed: ([value]) => value || '',
  },
  pageType: {
    property: ['T', 'F', 'P'],
    computed: ([T, F, P]) => {
      const ptf = `${P}_${T}_${F}`;
      if (/.*H.*_.*_.*/.test(ptf)) {
        return 'hong-kong-fund';
      }
      if (/.*G.*_.*_.*/.test(ptf)) {
        return 'high-end-fund';
      }
      return 'public-offer-fund';
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
